import React, { useEffect, useState } from 'react';
import { Typography, Button, TextField, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';
import apiService from '../../../utlis/apiService';
import { useUser } from '../../../context/userContext';

const MyTable = () => {
    const { permissions } = useUser();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false); // Track loading state
    const [totalResults, setTotalResults] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();
    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: 50,
        page: 0,
    });
    const pageOption = [10, 25, 50, 100];

    useEffect(() => {
        getData();
    }, [searchTerm, paginationModel]);

    // const handlePageChange = (newPage) => {
    //     setPage(newPage);
    // };

    const getData = async () => {
        setLoading(true); // Set loading to true when fetching data
        try {
            const response = await apiService.get('/level/list', {
                params: {
                    searchTerm: searchTerm,
                    page: paginationModel.page,
                    pageSize: paginationModel.pageSize,
                },
            });

            setData(response?.data?.levels);
            setTotalResults(response?.data?.totalResults);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false); // Set loading to false when data fetching is complete
        }
    };

    const deleteItem = async (id) => {
        const shouldDelete = window.confirm('Are you sure you want to delete this item?');
        if (shouldDelete) {
            try {
                setLoading(true); // Start loading
                await apiService.post('/level/delete', { id: id });
                getData();
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false); // Stop loading, whether success or error
            }
        }
    };

    const createPress = () => {
        clearLocalStorageKeysWithSubstring('FormData');
        navigate('/dashboard/category/add');
    };

    function clearLocalStorageKeysWithSubstring(substring) {
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.includes(substring)) {
                localStorage.removeItem(key);
            }
        }
    }

    return (
        <div>
            <div style={{ flexDirection: 'row', justifyContent: 'space-between', display: 'flex' }}>
                <Typography variant="h4" gutterBottom>
                    Categories
                </Typography>
                {permissions.includes('createCategory') && (
                    <Button variant="contained" color="primary" style={{ marginBottom: '16px' }} onClick={createPress}>
                        + Create
                    </Button>
                )}
            </div>
            <TextField
                label="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                fullWidth
                margin="dense"
                style={{ marginBottom: 10 }}
                size='small'
            />
            {loading ? ( // Render loader if loading is true
                <CircularProgress style={{ margin: '20px auto', display: 'block' }} />
            ) : (
                <div style={{ height: '70vh', width: '100%' }}>
                    <DataGridPro
                        rows={data}
                        getRowId={(row) => row._id}
                        columns={[
                            { field: 'name', headerName: 'Name', flex: 1 },
                            { field: 'year', headerName: 'Academic Year', flex: 1 },
                            { field: 'paperLimit', headerName: 'Paper Limit', flex: 1 },
                            { field: 'offline', headerName: 'Offline', flex: 1, valueGetter: (params) => {
                                let offlineItem = {}
                                if(params.row?.fee?.length){
                                    offlineItem = params.row?.fee.find(item=> item.mode === 'Offline');
                                    return offlineItem ? offlineItem.value : '-'
                                }
                            }, },
                            { field: 'online', headerName: 'Online', flex: 1, valueGetter: (params) => {
                                let onineItem = {}
                                if(params.row?.fee?.length){
                                    onineItem = params.row?.fee.find(item=> item.mode === 'Online');
                                    return onineItem ? onineItem.value : '-'
                                }
                            }, },
                            { field: 'recordings', headerName: 'Recordings', flex: 1, valueGetter: (params) => {
                                let onineItem = {}
                                if(params.row?.fee?.length){
                                    onineItem = params.row?.fee.find(item=> item.mode === 'Recordings');
                                    return onineItem ? onineItem.value : '-'
                                }
                            }, },
                            {
                                field: 'actions',
                                headerName: 'Action',
                                flex: 1,
                                renderCell: (params) => (
                                    <>
                                        {permissions.includes('readCategory') && (
                                            <Button variant="outlined" onClick={() => navigate(`/dashboard/category/view?id=${params.row._id}`)}>View</Button>
                                        )}
                                        {permissions.includes('updateCategory') && (
                                            <Button variant="outlined" style={{ marginLeft: 5 }} onClick={() => navigate(`/dashboard/category/add?id=${params.row._id}`)}>Edit</Button>
                                        )}
                                        {permissions.includes('deleteCategoryl') && (
                                            <Button variant="outlined" color="error" style={{ marginLeft: 5 }} onClick={() => deleteItem(params.row._id)}>Delete</Button>
                                        )}
                                    </>
                                ),
                            },
                        ]}
                        pagination
                        paginationModel={paginationModel}
                        rowCount={totalResults}
                        paginationMode="server"
                        components={{ Toolbar: GridToolbar }} // Add GridToolbar for filtering
                        onPaginationModelChange={setPaginationModel}
                        rowsPerPageOptions={pageOption}
                    />
                </div>
            )}
        </div>
    );
};

export default MyTable;
